/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_7_WInputs */

const en_cp_cal_7_w = /** @type {(inputs: Cp_Cal_7_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week 14`)
};

const id_cp_cal_7_w = /** @type {(inputs: Cp_Cal_7_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minggu 14`)
};

/**
* | output |
* | --- |
* | "Week 14" |
*
* @param {Cp_Cal_7_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_7_w = /** @type {((inputs?: Cp_Cal_7_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_7_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_7_w(inputs)
	return en_cp_cal_7_w(inputs)
});